import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Properties', href: '/properties' },
    { name: 'About', href: '/about' },
    { name: 'Services', href: '/services' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="text-2xl font-bold" style={{ color: '#E2725B' }}>
              Elite Real Estate
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-[#E2725B] border-b-2 border-[#E2725B]'
                    : 'text-[#2E2E2E] hover:text-[#FF914D]'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="tel:+442071234567"
              className="flex items-center text-[#2E2E2E] hover:text-[#E2725B] transition-colors"
            >
              <Phone className="h-4 w-4 mr-2" />
              020 7123 4567
            </a>
            <Button 
              className="bg-gradient-to-r from-[#E2725B] to-[#FF914D] hover:from-[#d65a43] hover:to-[#e8823d] text-white transition-all duration-300"
              asChild
            >
              <Link to="/contact">Book Consultation</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-[#2E2E2E] hover:text-[#E2725B] hover:bg-gray-100"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block px-3 py-2 text-base font-medium transition-colors ${
                  isActive(item.href)
                    ? 'text-[#E2725B] bg-[#FFF5E6]'
                    : 'text-[#2E2E2E] hover:text-[#FF914D] hover:bg-gray-50'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <div className="px-3 py-2 space-y-2">
              <a
                href="tel:+442071234567"
                className="flex items-center text-[#2E2E2E] hover:text-[#E2725B] transition-colors"
              >
                <Phone className="h-4 w-4 mr-2" />
                020 7123 4567
              </a>
              <Button 
                className="w-full bg-gradient-to-r from-[#E2725B] to-[#FF914D] hover:from-[#d65a43] hover:to-[#e8823d] text-white transition-all duration-300"
                asChild
              >
                <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Book Consultation</Link>
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;